const value = (name: string, fallback: string): string => {
  const raw = (import.meta.env as Record<string, unknown>)[name];
  return typeof raw === 'string' && raw.trim() ? raw.trim() : fallback;
};

export const config = {
  apiBaseUrl: value(
    'VITE_API_BASE_URL',
    'https://games.api.ayesearch.com',
  ).replace(/\/$/, ''),

  auth: {
    csrf: value('VITE_AUTH_CSRF_PATH', '/api/auth/csrf/'),
    login: value('VITE_AUTH_LOGIN_PATH', '/api/auth/login/'),
    register: value('VITE_AUTH_REGISTER_PATH', '/api/auth/register/'),
    me: value('VITE_AUTH_ME_PATH', '/api/auth/me/'),
    logout: value('VITE_AUTH_LOGOUT_PATH', '/api/auth/logout/'),
  },

  operationsBase: value(
    'VITE_OPERATIONS_BASE_PATH',
    '/api/operations/',
  ),
};

export const apiUrl = (path: string): string => {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${config.apiBaseUrl}${normalized}`;
};
